import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Box,
  Container,
  makeStyles,
  TableBody,
  TableHead,
  TablePagination,
  Avatar,
  Grid,
} from "@material-ui/core";
import PermMediaOutlinedIcon from "@material-ui/icons/PermMediaOutlined";
import { AuthContext } from "../context";
import {
  productsServices,
  doctorServices,
  laboratoryServices,
} from "../services";
import {
  Toast,
  ConfirmationModal,
  Loader,
  SimpleToolbar,
  AddProduct,
  EditProduct,
  Drawer,
  StyledTableCell,
  StyledTableRow,
  BaseTable,
} from "../components";
import { useDrawer } from "../hooks";
import { EditIconButton, DeleteIconButton } from "../components/icon-buttons/";
import { EditProductStatusModal } from "../components/edit-product-status";
import handleDownloadExcel from "../helpers/download-excel";
export default function ProductsScreen(props) {
  const classes = useStyles();
  const [products, setProducts] = useState([]);
  const { authState, signOut } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [productId, setProductId] = useState(null);
  const [reload, setReload] = useState(false);
  const [editProduct, setEditProduct] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [productToEdit, setProductToEdit] = useState(null);
  const [specialtiesList, setSpecialtiesList] = useState([]);
  const [childLaboratories, setChildLaboratories] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [product_id, setModalProductId] = useState(null);

  const { isOpen, setIsOpen } = useDrawer();
  const tableHeader = useRef([
    "Producto",
    "Molécula",
    "Presentaciones",
    "Concentración",
    "Precio de referencia",
    "Estado",
  ]);
  const tableBody = useRef([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const labId =
    user.role._id === "5fdb9e3db3bfce86908e440f"
      ? "ALL"
      : user.laboratory["_id"];

  function getProductStatus(status) {
    switch (status) {
      case "661821d27b4df03548c403f8":
        return "Disponible";
      case "661822077b4df03548c403f9":
        return "Suspendido temporalmente";
      case "661822297b4df03548c403fa":
        return "Sin muestras disponibles";
      case "661822407b4df03548c403fb":
        return "Agotado";
      default:
        return "Rechazado";
    }
  }

  useEffect(() => {
    const tableData = products.map((product) => {
      return {
        Producto: product.name || "",
        Molécula: product.molecule || "",
        Presentaciones: product.presentation || "",
        Concentración: product.concentration || "",
        "Precio de referencia": product.price || "",
        Estado: getProductStatus(product.status) || "",
      };
    });
    tableBody.current = tableData;
  }, [products]);

  useEffect(() => {
    getProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, authState, reload, signOut]);

  useEffect(() => {
    async function init() {
      try {
        const { status, response } = await doctorServices.getSpecialties();
        if (status === 200) {
          setSpecialtiesList(response.specialties);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        console.log(e);
      }
    }
    init();
  }, [doctorServices, setSpecialtiesList, signOut]);

  useEffect(() => {
    async function getChildLaboratories() {
      if (authState.user.role.name === "LABORATORY_ADMIN") {
        try {
          const { status, response } =
            await laboratoryServices.getChildLaboratories({
              laboratoryId: authState.user.laboratory._id,
              token: authState.token,
              text: "",
            });
          if (status === 200) {
            setChildLaboratories(response.laboratories);
          }
        } catch (e) {
          console.log(e);
        }
      }
    }
    getChildLaboratories();
  }, [authState]);

  const getProducts = async (text = "") => {
    setReload(false);
    try {
      setLoading(true);
      const { status, response } = await productsServices.getProductsFilter({
        text,
        laboratoryId: labId,
        page,
        limit,
        token: authState.token,
      });
      setLoading(false);
      if (status === 200) {
        setProducts(response.products);
        setLimit(response.limit);
        setCount(response.total);
        setPage(response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const deleteProduct = async () => {
    try {
      setLoading(true);
      const { status, response } = await productsServices.deleteProduct({
        productId,
        token: authState.token,
      });
      setLoading(false);
      if (status === 200) {
        setReload(true);
        setToast(true);
        setToastMessage(response.message);
      } else if (status === 401) {
        signOut();
      }
      if (response.error) {
        setToast(true);
        setToastMessage(response.error.message);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const confirmationModal = (_id) => {
    setOpenAlert(true);
    setProductId(_id);
  };

  const handleToast = (message, active) => {
    setToastMessage(message);
    setToast(active);
  };

  const optionsToolbar = [
    {
      label: "Exportar excel",
      action: (e) => {
        handleDownloadExcel({
          filename: "Productos",
          tableBody: tableBody.current,
          tableHeader: tableHeader.current,
        });
      },
    },
    {
      label: "Agregar",
      action: (e) => {
        setOpenAddModal(true);
      },
    },
  ];

  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.container} style={{ flex: 1 }}>
        {loading && <Loader loading={true} />}
        {editProduct && (
          <EditProduct
            open={true}
            close={() => setEditProduct(false)}
            toast={(message, active) => handleToast(message, active)}
            reload={() => setReload(true)}
            product={productToEdit}
            specialtiesList={specialtiesList}
            childLaboratories={childLaboratories}
            refetch={getProducts}
          />
        )}
        {openAddModal && (
          <AddProduct
            open={openAddModal}
            close={() => setOpenAddModal(false)}
            toast={(message, active) => handleToast(message, active)}
            reload={() => setReload(true)}
            specialtiesList={specialtiesList}
            childLaboratories={childLaboratories}
            refetch={getProducts}
          />
        )}
        <Grid item sm={12} xs={12}>
          <div className={classes.root}>
            <Toast
              message={toastMessage}
              open={toast}
              close={() => {
                setToast(false);
              }}
            />
            <ConfirmationModal
              open={openAlert}
              setOpenAlert={setOpenAlert}
              setConfirmAction={() => deleteProduct()}
            />
            <Container maxWidth={false}>
              <SimpleToolbar
                setIsOpen={(value) => setIsOpen(value)}
                isOpen={isOpen}
                onFilter={(text) => getProducts(text)}
                options={optionsToolbar}
              />
              <BaseTable tableId="tableDoctors">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell style={{ textAlign: "start" }}>
                      Producto
                    </StyledTableCell>
                    <StyledTableCell>Molécula</StyledTableCell>
                    {/* <StyledTableCell>Indicaciones</StyledTableCell> */}
                    <StyledTableCell>Presentaciones</StyledTableCell>
                    <StyledTableCell>Concentración</StyledTableCell>
                    <StyledTableCell>Precio de referencia</StyledTableCell>
                    {authState.user.role.name === "LABORATORY_ADMIN" && (
                      <StyledTableCell>Unidad de negocio</StyledTableCell>
                    )}
                    <StyledTableCell>Estado</StyledTableCell>
                    <StyledTableCell>Opciones</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {products.map((product, index) => (
                    <StyledTableRow hover key={product._id}>
                      <StyledTableCell>
                        <Box
                          alignItems="center"
                          display="flex"
                          // justifyContent={"center"}
                        >
                          <Avatar className={classes.avatar} src={product.logo}>
                            <PermMediaOutlinedIcon />
                          </Avatar>
                          {product.name}
                        </Box>
                      </StyledTableCell>
                      <StyledTableCell>
                        {product.molecule ? product.molecule : ""}
                      </StyledTableCell>
                      {/* <StyledTableCell
                      
                      >
                        {product.indications ? product.indications : ""}
                      </StyledTableCell> */}
                      <StyledTableCell>
                        {product.presentation ? product.presentation : ""}
                      </StyledTableCell>
                      <StyledTableCell>{product.concentration}</StyledTableCell>
                      <StyledTableCell>{product.price}</StyledTableCell>
                      {authState.user.role.name === "LABORATORY_ADMIN" && (
                        <StyledTableCell>
                          {product.laboratory.name}
                        </StyledTableCell>
                      )}
                      <StyledTableCell>
                        {product.status === "661821d27b4df03548c403f8"
                          ? "Disponible"
                          : product.status === "661822077b4df03548c403f9"
                          ? "Suspendido temporalmente"
                          : product.status === "661822297b4df03548c403fa"
                          ? "Sin muestras disponibles"
                          : product.status === "661822407b4df03548c403fb"
                          ? "Agotado"
                          : "Rechazado"}
                      </StyledTableCell>
                      <StyledTableCell>
                        {/* <EditIconButton
                          tooltipTitle="Editar producto"
                          onClick={() => {
                            setOpenModal(true);
                            setModalProductId(product._id);
                          }}
                        /> */}
                        <EditIconButton
                          tooltipTitle="Editar producto"
                          onClick={() => {
                            setEditProduct(true);
                            setProductToEdit(product);
                          }}
                        />
                        <DeleteIconButton
                          onClick={() => confirmationModal(product._id)}
                          tooltipTitle="Borrar producto"
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </BaseTable>
              <TablePagination
                labelRowsPerPage="Registros por página"
                component="div"
                count={count}
                onChangeRowsPerPage={(e) => setLimit(e.target.value)}
                onChangePage={(e, page) => setPage(page + 1)}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                classes={{ root: classes.pagination }}
              />
            </Container>
          </div>
        </Grid>
      </Grid>

      <EditProductStatusModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        assigmentId={product_id}
        setOpenModal={setOpenModal}
        getProducts={getProducts}
      />
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  pagination: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      bottom: 0,
    },
  },
}));
